import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaRocket, FaBrain, FaUsers } from 'react-icons/fa';
 
const About = () => {
  const highlights = [
    {
      icon: <FaCode />,
      title: 'Clean Code',
      description: 'Writing maintainable, scalable, and well-documented code following industry best practices',
    },
    {
      icon: <FaRocket />,
      title: 'Performance',
      description: 'Optimizing applications for speed, efficiency, and exceptional user experience',
    },
    {
      icon: <FaBrain />,
      title: 'AI Integration',
      description: 'Leveraging cutting-edge AI technologies like RAG, LangChain, and Pinecone for intelligent solutions',
    },
    {
      icon: <FaUsers />,
      title: 'Collaboration',
      description: 'Strong team player with excellent communication skills and agile methodology expertise',
    },
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">Passionate developer crafting digital experiences</p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="about-intro">
              I'm a <strong>MERN Stack Developer</strong> with <strong>2.8+ years</strong> of hands-on experience
              designing, developing, and deploying scalable, high-performance web applications.
            </p>

            <p>
              My expertise spans the entire full-stack development lifecycle—from architecting optimized NoSQL databases
              and building robust RESTful APIs to crafting modern, responsive user interfaces with React.js and Next.js.
            </p>

            <p>
              I specialize in <strong>advanced state management architectures</strong> (Redux, Zustand, Recoil),
              <strong> TypeScript-based development</strong>, and <strong>AI integration</strong> using LangChain,
              Pinecone, and Retrieval-Augmented Generation (RAG) to build intelligent, context-aware applications.
            </p>

            <p>
              Currently working at <strong>Stack Up Solutions</strong>, I've successfully delivered enterprise-grade
              projects ahead of schedule, reduced runtime bugs by 40% through strict TypeScript implementation,
              and spearheaded AI-powered features that significantly increased user engagement.
            </p>

            <p>
              I'm passionate about staying at the forefront of web development trends, writing clean and maintainable code,
              and solving complex problems with elegant solutions.
            </p>
          </motion.div>

          <motion.div
            className="about-highlights"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            {highlights.map((item, index) => (
              <motion.div
                key={index}
                className="highlight-card"
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <div className="highlight-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;